var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto app-content-back"},[(_vm.event)?_c('div',{staticClass:"p-4"},[_c('h1',{staticClass:"text-4xl"},[_vm._v(" "+_vm._s(_vm.event.title)+" ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }